import React from 'react';

const Footer = () => (
  <footer className="text-center py-2 border-top text-muted small">
    © 2025 First Tech Tracking | Excellence in GPS Tracking | Contact Us
  </footer>
);

export default Footer;